import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const translations = {
  en: {
    nav_activities: "Activities", nav_dashboard: "My Trips", nav_admin: "Admin",
    login: "Sign in", logout: "Sign out", book_now: "Book Now",
    hero_title: "Your Alanya activity companion",
    hero_sub: "Discover, book and enjoy the best tours, watersports and local experiences in minutes.",
    search_placeholder: "Search boat tours, watersports, sightseeing...",
    explore: "Explore", featured: "Featured Experiences", browse_category: "Browse by category",
    all: "All", from: "from", per_person: "per person", duration: "Duration",
    instant: "Instant Booking", free_cancel: "Free Cancellation", verified: "Verified Operator",
    reviews: "reviews", inclusions: "What's included", pickup: "Pickup & meeting point",
    select_date: "Select date", select_time: "Time", guests: "Guests", total: "Total",
    proceed_pay: "Proceed to payment", ask_ai: "Ask our AI travel assistant",
    my_bookings: "My Bookings", favorites: "Favorites", no_bookings: "No bookings yet",
    view_details: "View details", filters: "Filters", price_range: "Price range",
    sort: "Sort", sort_recommended: "Recommended", sort_price_low: "Price: Low to High",
    sort_price_high: "Price: High to Low", sort_rating: "Top rated", results: "experiences found",
    trust_title: "Book with confidence", write_review: "Write a review",
    ai_greeting: "Hi! I'm your Alanya travel assistant. Ask me anything — from the best boat tour to a perfect day plan!",
    location: "Location & directions", get_directions: "Get directions",
    login_prompt: "Sign in to book this experience", cancel: "Cancel", confirmed: "Confirmed",
    pending: "Pending payment", cancelled: "Cancelled", paid: "Paid",
    pay_online: "Pay online now", pay_cash: "Pay cash on arrival", cash_booked: "Reserved! Pay cash on arrival.", pay_on_arrival: "Pay on arrival", refunded: "Refunded",
  },
  tr: {
    nav_activities: "Aktiviteler", nav_dashboard: "Gezilerim", nav_admin: "Yönetim",
    login: "Giriş yap", logout: "Çıkış", book_now: "Hemen Rezerve Et",
    hero_title: "Alanya aktivite rehberiniz",
    hero_sub: "En iyi tekne turlarını, su sporlarını ve yerel deneyimleri dakikalar içinde keşfedin ve rezerve edin.",
    search_placeholder: "Tekne turu, su sporları, gezi ara...",
    explore: "Keşfet", featured: "Öne Çıkan Deneyimler", browse_category: "Kategoriye göz atın",
    all: "Tümü", from: "başlangıç", per_person: "kişi başı", duration: "Süre",
    instant: "Anında Rezervasyon", free_cancel: "Ücretsiz İptal", verified: "Onaylı Operatör",
    reviews: "değerlendirme", inclusions: "Neler dahil", pickup: "Alış ve buluşma noktası",
    select_date: "Tarih seçin", select_time: "Saat", guests: "Kişi", total: "Toplam",
    proceed_pay: "Ödemeye geç", ask_ai: "Yapay zeka asistanına sorun",
    my_bookings: "Rezervasyonlarım", favorites: "Favoriler", no_bookings: "Henüz rezervasyon yok",
    view_details: "Detayları gör", filters: "Filtreler", price_range: "Fiyat aralığı",
    sort: "Sırala", sort_recommended: "Önerilen", sort_price_low: "Fiyat: Artan",
    sort_price_high: "Fiyat: Azalan", sort_rating: "En yüksek puan", results: "deneyim bulundu",
    trust_title: "Güvenle rezervasyon yapın", write_review: "Değerlendirme yaz",
    ai_greeting: "Merhaba! Ben Alanya seyahat asistanınızım. En iyi tekne turundan mükemmel bir güne kadar her şeyi sorun!",
    location: "Konum ve yol tarifi", get_directions: "Yol tarifi al",
    login_prompt: "Rezervasyon için giriş yapın", cancel: "İptal", confirmed: "Onaylandı",
    pending: "Ödeme bekleniyor", cancelled: "İptal edildi", paid: "Ödendi",
    pay_online: "Şimdi çevrimiçi öde", pay_cash: "Varışta nakit öde", cash_booked: "Rezervasyon alındı! Varışta nakit ödeyin.", pay_on_arrival: "Varışta ödeme", refunded: "İade edildi",
  },
  de: {
    nav_activities: "Aktivitäten", nav_dashboard: "Meine Reisen", nav_admin: "Admin",
    login: "Anmelden", logout: "Abmelden", book_now: "Jetzt buchen",
    hero_title: "Ihr Alanya-Aktivitätenbegleiter",
    hero_sub: "Entdecken und buchen Sie die besten Touren, Wassersport und lokale Erlebnisse in Minuten.",
    search_placeholder: "Bootstouren, Wassersport, Sightseeing suchen...",
    explore: "Entdecken", featured: "Ausgewählte Erlebnisse", browse_category: "Nach Kategorie",
    all: "Alle", from: "ab", per_person: "pro Person", duration: "Dauer",
    instant: "Sofortbuchung", free_cancel: "Kostenlose Stornierung", verified: "Geprüfter Anbieter",
    reviews: "Bewertungen", inclusions: "Inklusive", pickup: "Abholung & Treffpunkt",
    select_date: "Datum wählen", select_time: "Uhrzeit", guests: "Gäste", total: "Gesamt",
    proceed_pay: "Zur Zahlung", ask_ai: "Fragen Sie unseren KI-Assistenten",
    my_bookings: "Meine Buchungen", favorites: "Favoriten", no_bookings: "Noch keine Buchungen",
    view_details: "Details ansehen", filters: "Filter", price_range: "Preisspanne",
    sort: "Sortieren", sort_recommended: "Empfohlen", sort_price_low: "Preis: aufsteigend",
    sort_price_high: "Preis: absteigend", sort_rating: "Top bewertet", results: "Erlebnisse gefunden",
    trust_title: "Buchen Sie mit Vertrauen", write_review: "Bewertung schreiben",
    ai_greeting: "Hallo! Ich bin Ihr Alanya-Reiseassistent. Fragen Sie mich alles!",
    location: "Standort & Wegbeschreibung", get_directions: "Route anzeigen",
    login_prompt: "Zum Buchen anmelden", cancel: "Stornieren", confirmed: "Bestätigt",
    pending: "Zahlung ausstehend", cancelled: "Storniert", paid: "Bezahlt",
    pay_online: "Jetzt online bezahlen", pay_cash: "Barzahlung bei Ankunft", cash_booked: "Reserviert! Barzahlung bei Ankunft.", pay_on_arrival: "Zahlung bei Ankunft", refunded: "Erstattet",
  },
  ru: {
    nav_activities: "Активности", nav_dashboard: "Мои поездки", nav_admin: "Админ",
    login: "Войти", logout: "Выйти", book_now: "Забронировать",
    hero_title: "Ваш гид по развлечениям в Алании",
    hero_sub: "Находите и бронируйте лучшие туры, водные виды спорта и местные впечатления за минуты.",
    search_placeholder: "Морские туры, водный спорт, экскурсии...",
    explore: "Смотреть", featured: "Популярные впечатления", browse_category: "По категориям",
    all: "Все", from: "от", per_person: "с человека", duration: "Длительность",
    instant: "Мгновенное бронирование", free_cancel: "Бесплатная отмена", verified: "Проверенный оператор",
    reviews: "отзывов", inclusions: "Что включено", pickup: "Трансфер и место встречи",
    select_date: "Выберите дату", select_time: "Время", guests: "Гости", total: "Итого",
    proceed_pay: "Перейти к оплате", ask_ai: "Спросите ИИ-помощника",
    my_bookings: "Мои брони", favorites: "Избранное", no_bookings: "Пока нет броней",
    view_details: "Подробнее", filters: "Фильтры", price_range: "Диапазон цен",
    sort: "Сортировка", sort_recommended: "Рекомендуем", sort_price_low: "Цена: по возрастанию",
    sort_price_high: "Цена: по убыванию", sort_rating: "Лучший рейтинг", results: "впечатлений найдено",
    trust_title: "Бронируйте с уверенностью", write_review: "Написать отзыв",
    ai_greeting: "Привет! Я ваш помощник по Алании. Спрашивайте что угодно!",
    location: "Локация и маршрут", get_directions: "Построить маршрут",
    login_prompt: "Войдите, чтобы забронировать", cancel: "Отменить", confirmed: "Подтверждено",
    pending: "Ожидает оплаты", cancelled: "Отменено", paid: "Оплачено",
    pay_online: "Оплатить онлайн", pay_cash: "Оплата наличными по прибытии", cash_booked: "Забронировано! Оплата наличными по прибытии.", pay_on_arrival: "Оплата по прибытии", refunded: "Возвращено",
  },
};

export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("alanya_lang") || "en");
  useEffect(() => { localStorage.setItem("alanya_lang", lang); }, [lang]);
  const t = useCallback((key) => translations[lang]?.[key] || translations.en[key] || key, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
